// extracted by mini-css-extract-plugin
module.exports = {"page404":"clinical-portal-3__shell__page404"};